import { render, staticRenderFns } from "./_question.vue?vue&type=template&id=217852fa&"
import script from "./_question.vue?vue&type=script&lang=js&"
export * from "./_question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports